import React, { useState } from "react";
import { Globe, Menu, X } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/images/logo.png";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const handleNavClick = (sectionId) => {
    setIsMenuOpen(false);

    // If we're already on the home page, scroll to section
    if (location.pathname === "/") {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // If we're on another page, navigate to home page with hash
      window.location.href = `/#${sectionId}`;
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <header className="w-full flex items-center justify-between px-4 sm:px-6 lg:px-10 py-3 bg-white border-b relative sticky top-0 z-50">
      {/* Left: Logo */}
      <div className="flex items-center gap-3">
        <Link to="/" onClick={scrollToTop}>
          <img
            src={logo}
            alt="Logo"
            className="w-full h-12 object-contain cursor-pointer"
          />
        </Link>
      </div>

      {/* Center: Navigation - Desktop */}
      <nav className="hidden lg:flex items-center gap-8 text-gray-800 font-medium">
        <button
          onClick={() => handleNavClick("about")}
          className="hover:text-orange-500 transition bg-transparent border-none cursor-pointer"
        >
          About Us
        </button>
        <button
          onClick={() => handleNavClick("company-introduction")}
          className="hover:text-orange-500 transition bg-transparent border-none cursor-pointer"
        >
          Services
        </button>
        <button
          onClick={() => handleNavClick("achievements")}
          className="hover:text-orange-500 transition bg-transparent border-none cursor-pointer"
        >
          Products
        </button>
        <button
          onClick={() => handleNavClick("partner")}
          className="hover:text-orange-500 transition bg-transparent border-none cursor-pointer"
        >
          Partners
        </button>
        <button
          onClick={() => handleNavClick("contact")}
          className="hover:text-orange-500 transition bg-transparent border-none cursor-pointer"
        >
          Contact Us
        </button>
      </nav>

      {/* Right: Language and Login - Desktop */}
      <div className="hidden sm:flex items-center gap-3">
        <button className="p-2 border border-orange-500 rounded-md hover:bg-orange-50 transition flex items-center gap-1 text-orange-500">
          <Globe size={16} />
          <span className="text-sm font-semibold">En</span>
        </button>
        <button className="bg-orange-500 text-white px-4 py-2 rounded-md font-semibold hover:bg-orange-600 transition text-sm">
          Login
        </button>
      </div>

      {/* Mobile menu button */}
      <button
        className="sm:hidden p-2 text-gray-700"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Mobile Navigation Menu */}
      {isMenuOpen && (
        <div className="absolute top-full left-0 w-full bg-white border-b shadow-lg sm:hidden z-50">
          <div className="flex flex-col p-4">
            <nav className="flex flex-col gap-0 text-gray-800 font-medium mb-4">
              <button
                onClick={() => handleNavClick("about")}
                className="hover:text-orange-500 transition py-3 border-b text-left bg-transparent border-none cursor-pointer"
              >
                About Us
              </button>
              <button
                onClick={() => handleNavClick("company-introduction")}
                className="hover:text-orange-500 transition py-3 border-b text-left bg-transparent border-none cursor-pointer"
              >
                Services
              </button>
              <button
                onClick={() => handleNavClick("achievements")}
                className="hover:text-orange-500 transition py-3 border-b text-left bg-transparent border-none cursor-pointer"
              >
                Products
              </button>
              <button
                onClick={() => handleNavClick("partner")}
                className="hover:text-orange-500 transition py-3 border-b text-left bg-transparent border-none cursor-pointer"
              >
                Partners
              </button>
              <button
                onClick={() => handleNavClick("contact")}
                className="hover:text-orange-500 transition py-3 border-b text-left bg-transparent border-none cursor-pointer"
              >
                Contact Us
              </button>
            </nav>

            {/* Mobile Language and Login */}
            <div className="flex items-center gap-3 pt-4 border-t">
              <button className="p-2 border border-orange-500 rounded-md hover:bg-orange-50 transition flex items-center gap-1 text-orange-500 flex-1 justify-center">
                <Globe size={16} />
                <span className="text-sm font-semibold">En</span>
              </button>
              <button className="bg-orange-500 text-white px-4 py-2 rounded-md font-semibold hover:bg-orange-600 transition text-sm flex-1">
                Login
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
